import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/_atoms/button";
import IconExclamationSolid from "@/components/_icons/IconExclamationSolid";

export interface NotFoundPageProps extends PropsWithChildren {
  title?: string;
  text?: string;
}

export const NotFoundView: FC<NotFoundPageProps> = ({ title, text, children }) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  return (
    <div className="relative flex h-screen select-none justify-center overflow-auto">
      <div className="relative flex max-w-md flex-col items-center self-center px-6 text-center">
        <h4 className="relative flex grow items-stretch overflow-hidden align-middle text-sm">
          <IconExclamationSolid className="my-auto mr-2 h-3 w-3" aria-hidden="true" />
          {title ?? t("notFound.title")}
        </h4>
        <p className="mt-4 text-center text-xs text-muted-foreground">{text ?? t("notFound.description")}</p>
        {children ?? (
          <Button onClick={() => navigate("/")} variant="default" className="mt-6">
            {t("notFound.backToHome")}
          </Button>
        )}
      </div>
    </div>
  );
};
